const NS = 'passwordInput';

const PasswordInput = class {

    constructor() {
        this.$el = $('.js-password-input');

        if (this.$el.length < 1) {
            return;
        }

        this.$toggle = this.$el.find('.js-toggle');
        this.$input = this.$el.find('.js-input');

        this.$toggle.on(`click.${NS}`, () => {
            this.handleToggle();
        });

    }

    handleToggle() {

        const inputType = this.$input.attr('type');

        if (inputType === 'password') {
            this.$input.attr('type', 'text');
            this.$toggle.text('Hide');
        } else {
            this.$input.attr('type', 'password');
            this.$toggle.text('Show');
        }
    }

};

new PasswordInput();

